// extracted by mini-css-extract-plugin
export default {"MainCont":"Oven_MainCont__zPztd","LeftCont":"Oven_LeftCont__A4TxQ","RightCont":"Oven_RightCont__9K1N9"};